// /**
//  * directives.autocomplete Module
//  *
//  * Description
//  */
// var app = angular.module('directives.autocomplete', []);
//
// app.filter('afilter', [function () {
//     return function (array, searchStr) {
//         if (!searchStr) return array;
//         var searchWords = searchStr.split(" ").map(function (s) {
//             return s.toLowerCase();
//         });
//         var resArray = array.filter(function (f) {
//             var lowerWord = f.toLowerCase();
//             var res = searchWords.every(function (s) {
//                 return lowerWord.indexOf(s) > -1;
//             });
//             return res;
//         });
//         return resArray;
//     };
// }]);
//
// app.directive('autocomplete', function() {
//     var index = -1;
//
//     return {
//         restrict: 'E',
//         scope: {
//             requestType: '=requestType',
//             searchParam: '=ngModel',
//             suggestions: '=data',
//             vocabulary: '=vocabulary',
//             vocabularyType: '=vocabularyType',
//             onType: '=onType',
//             status: '=',
//             onSelect: '=onSelect',
//             autocompleteRequired: '=autocompleteRequired',
//             onClose: '=closeDropdown',
//         },
//         controller: ['$scope', 'Combobox', 'Pay', '$window', function($scope, Combobox, Pay, $window){
//
//             $scope.pay = Pay;
//             $scope.selected = false;
//             $scope.preloader = false;
//
//             $scope.Combo = Combobox;
//             $scope.selectedValue = Combobox.selectedRegion;
//
//             // the index of the suggestions that's currently selected
//             $scope.selectedIndex = -1;
//
//             $scope.initLock = true;
//
//             // set new index
//             $scope.setIndex = function(i){
//                 $scope.selectedIndex = parseInt(i);
//             };
//
//             this.setIndex = function(i){
//                 $scope.setIndex(i);
//                 $scope.$apply();
//             };
//
//             $scope.getIndex = function(i){
//                 return $scope.selectedIndex;
//             };
//
//             // watches if the parameter filter should be changed
//             var watching = true;
//
//             // autocompleting drop down on/off
//             $scope.completing = false;
//
//             // starts autocompleting on typing in something
//             $scope.$watch('searchParam', function(newValue, oldValue){
//                 if (!watching || oldValue === newValue || (!oldValue && $scope.initLock)) {
//                     return;
//                 }
//
//                 if ($scope.vocabularyType != 'ONLINE' ) {
//                     if(watching && typeof $scope.searchParam !== 'undefined' && $scope.searchParam !== null) {
//                         $scope.completing = true;
//                         $scope.searchFilter = $scope.searchParam;
//                         $scope.selectedIndex = -1;
//                         if(newValue && $scope.suggestions && $scope.suggestions.includes(newValue)) {
//                             $scope.selectedValue = newValue;
//                         }
//
//                     }
//
//                     // function thats passed to on-type attribute gets executed
//                     $scope.pay.data.comboLoader = true;
//                     if ($scope.onType) {
//                         $scope.onType($scope.searchParam, $scope.vocabulary, $scope.requestType );
//                     }
//                 }
//             });
//
//             $scope.onlineSearch = function (e) {
//                 $scope.completing = true;
//                 $scope.pay.data.comboLoader = true;
//                 if ($scope.onType) {
//                     $scope.onType($scope.searchParam, $scope.vocabulary, $scope.requestType);
//                 }
//                 e.stopPropagation();
//             };
//
//             // for hovering over suggestions
//             this.preSelect = function(suggestion){
//
//                 watching = false;
//
//                 // this line determines if it is shown
//                 // in the input field before it's selected:
//                 //$scope.searchParam = suggestion;
//
//                 $scope.$apply();
//                 watching = true;
//
//             };
//
//             $scope.preSelect = this.preSelect;
//
//             this.preSelectOff = function(){
//                 watching = true;
//             };
//
//             $scope.preSelectOff = this.preSelectOff;
//
//             // selecting a suggestion with RIGHT ARROW or ENTER
//             $scope.select = function(suggestion){
//                 if(suggestion){
//                     $scope.selectedValue = suggestion;
//                     $scope.searchParam = suggestion;
//                     $scope.searchFilter = suggestion;
//                     if($scope.onSelect) {
//                         $scope.onSelect(suggestion, $scope.requestType);
//                         $scope.selected = true;
//                     }
//                 }
//                 // $scope.completing = false;
//                 watching = false;
//                 setTimeout(function(){
//                     watching = true;
//                 },1000);
//                 $scope.setIndex(-1);
//             };
//
//             $scope.valueChanged = function (val) {
//                 if(val && $scope.suggestions && $scope.suggestions.includes(val)) {
//                     $scope.selectedValue = val;
//                 }
//             }
//
//             angular.element($window).on('click', function (event) {
//                     var target = $(event.target);
//
//                     if(target.hasClass("search-online-combo")) {
//                         // just ignore
//                     } else {
//                         // Do whatever you need
//                         $scope.completing = false;
//                     }
//                     $scope.$apply();
//             });
//
//             $scope.clearField = function () {
//                 $scope.searchParam = ''
//             }
//
//         }],
//         link: function(scope, element, attrs){
//
//             setTimeout(function() {
//                 scope.initLock = false;
//                 scope.$apply();
//             }, 250);
//
//             var attr = '';
//
//             // Default atts
//             scope.attrs = {
//                 "placeholder": "start typing...",
//                 "class": "",
//                 "id": "",
//                 "inputclass": "",
//                 "inputid": ""
//             };
//
//             for (var a in attrs) {
//                 attr = a.replace('attr', '').toLowerCase();
//                 // add attribute overriding defaults
//                 // and preventing duplication
//                 if (a.indexOf('attr') === 0) {
//                     scope.attrs[attr] = attrs[a];
//                 }
//             }
//
//             if (attrs.clickActivation) {
//                 element[0].onclick = function(e){
//                     if(!scope.searchParam){
//                         setTimeout(function() {
//                             scope.completing = true;
//                             scope.$apply();
//                         }, 200);
//                     }
//                 };
//             }
//
//             var key = {left: 37, up: 38, right: 39, down: 40 , enter: 13, esc: 27, tab: 9};
//
//             document.addEventListener("keydown", function(e){
//                 var keycode = e.keyCode || e.which;
//
//                 switch (keycode){
//                     case key.esc:
//                         // disable suggestions on escape
//                         scope.select();
//                         scope.setIndex(-1);
//                         scope.$apply();
//                         e.preventDefault();
//                 }
//             }, true);
//
//             // document.addEventListener("blur", function(e){
//             //     // disable suggestions on blur
//             //     // we do a timeout to prevent hiding it before a click event is registered
//             //     setTimeout(function() {
//             //         // scope.select();
//             //         scope.setIndex(-1);
//             //         scope.$apply();
//             //     }, 150);
//             // }, true);
//
//             element[0].addEventListener("keydown",function (e){
//                 var keycode = e.keyCode || e.which;
//
//                 var l = angular.element(this).find('li').length;
//
//                 // this allows submitting forms by pressing Enter in the autocompleted field
//                 if(!scope.completing || l == 0) return;
//
//                 // implementation of the up and down movement in the list of suggestions
//                 switch (keycode){
//                     case key.up:
//
//                         index = scope.getIndex()-1;
//                         if(index<-1){
//                             index = l-1;
//                         } else if (index >= l ){
//                             index = -1;
//                             scope.setIndex(index);
//                             scope.preSelectOff();
//                             break;
//                         }
//                         scope.setIndex(index);
//
//                         if(index!==-1)
//                             scope.preSelect(angular.element(angular.element(this).find('li')[index+1]).text());
//
//                         scope.$apply();
//
//                         break;
//                     case key.down:
//                         index = scope.getIndex()+1;
//                         if(index<-1){
//                             index = l-1;
//                         } else if (index >= l ){
//                             index = -1;
//                             scope.setIndex(index);
//                             scope.preSelectOff();
//                             scope.$apply();
//                             break;
//                         }
//                         scope.setIndex(index);
//
//                         if(index!==-1)
//                             scope.preSelect(angular.element(angular.element(this).find('li')[index+1]).text());
//
//                         break;
//                     case key.left:
//                         break;
//                     case key.right:
//                     case key.enter:
//                     case key.tab:
//
//                         index = scope.getIndex();
//                         // scope.preSelectOff();
//                         if(index !== -1) {
//                             scope.select(angular.element(angular.element(this).find('li')[index+1]).text());
//                             if(keycode == key.enter) {
//                                 e.preventDefault();
//                             }
//                         } else {
//                             if(keycode == key.enter) {
//                                 scope.select();
//                             }
//                         }
//                         scope.setIndex(-1);
//                         scope.$apply();
//
//                         break;
//                     case key.esc:
//                         // disable suggestions on escape
//                         scope.select();
//                         scope.setIndex(-1);
//                         scope.$apply();
//                         e.preventDefault();
//                         break;
//                     default:
//                         return;
//                 }
//
//             });
//         },
//         template:require('../templates/index.html'),
//     };
// });
//
// app.filter('highlight', ['$sce', function ($sce) {
//     return function (input, searchParam) {
//         if (typeof input === 'function') return '';
//         if (searchParam) {
//             var words = '(' +
//                 searchParam.split(/\ /).join(' |') + '|' +
//                 searchParam.split(/\ /).join('|') +
//                 ')',
//                 exp = new RegExp(words, 'gi');
//             if (words.length) {
//                 input = input.replace(exp, "<span class=\"highlight\">$1</span>");
//             }
//         }
//         return $sce.trustAsHtml(input);
//     };
// }]);
//
// app.directive('suggestion', function(){
//     return {
//         restrict: 'A',
//         require: '^autocomplete', // ^look for controller on parents element
//         link: function(scope, element, attrs, autoCtrl){
//             element.bind('mouseenter', function() {
//                 autoCtrl.preSelect(attrs.val);
//                 autoCtrl.setIndex(attrs.index);
//             });
//
//             element.bind('mouseleave', function() {
//                 autoCtrl.preSelectOff();
//             });
//         }
//     };
// });
//
//
// module.exports = angular;

/**
 * directives.autocomplete Module
 *
 * Description
 */
var app = angular.module('directives.autocomplete', []);

app.filter('afilter', [function () {
    return function (array, searchStr) {
        if (!searchStr) return array;
        var searchWords = searchStr.split(" ").map(function (s) {
            return s.toLowerCase();
        });
        var resArray = array.filter(function (f) {
            var lowerWord = f.toLowerCase();
            var res = searchWords.every(function (s) {
                return lowerWord.indexOf(s) > -1;
            });
            return res;
        });
        return resArray;
    };
}]);

app.directive('autocomplete', function() {
    var index = -1;

    return {
        restrict: 'E',
        scope: {
            requestType: '=requestType',
            searchParam: '=ngModel',
            suggestions: '=data',
            vocabulary: '=vocabulary',
            dependency: '=dependency',
            vocabularyType: '=vocabularyType',
            onType: '=onType',
            status: '=',
            onSelect: '=onSelect',
            autocompleteRequired: '=autocompleteRequired',
            onClose: '=closeDropdown',
        },
        controller: ['$scope', 'Combobox', 'Pay', '$window', function($scope, Combobox, Pay, $window){

            $scope.pay = Pay;
            $scope.selected = false;
            $scope.preloader = false;

            $scope.Combo = Combobox;

            // the index of the suggestions that's currently selected
            $scope.selectedIndex = -1;

            $scope.initLock = true;

            // set new index
            $scope.setIndex = function(i){
                $scope.selectedIndex = parseInt(i);
            };

            this.setIndex = function(i){
                $scope.setIndex(i);
                $scope.$apply();
            };

            $scope.getIndex = function(i){
                return $scope.selectedIndex;
            };

            // watches if the parameter filter should be changed
            var watching = true;

            // autocompleting drop down on/off
            $scope.completing = false;

            // starts autocompleting on typing in something
            $scope.$watch('searchParam', function(newValue, oldValue){
                if (!watching || oldValue === newValue || (!oldValue && $scope.initLock)) {
                    return;
                }

                if ($scope.vocabularyType != 'ONLINE' ) {
                    if(watching && typeof $scope.searchParam !== 'undefined' && $scope.searchParam !== null) {
                        $scope.completing = true;
                        $scope.searchFilter = $scope.searchParam;
                        $scope.selectedIndex = -1;
                    }

                    // function thats passed to on-type attribute gets executed
                    $scope.pay.data.comboLoader = true;
                    if ($scope.onType) {
                        $scope.onType($scope.searchParam, $scope.vocabulary, $scope.requestType, $scope.dependency);
                    }
                }
            });

            $scope.onlineSearch = function (e) {
                $scope.completing = true;
                $scope.pay.data.comboLoader = true;
                if ($scope.onType) {
                    $scope.onType($scope.searchParam, $scope.vocabulary, $scope.requestType, $scope.dependency);
                }
                e.stopPropagation();
            };

            // for hovering over suggestions
            this.preSelect = function(suggestion){

                watching = false;

                // this line determines if it is shown
                // in the input field before it's selected:
                //$scope.searchParam = suggestion;

                $scope.$apply();
                watching = true;

            };

            $scope.preSelect = this.preSelect;

            this.preSelectOff = function(){
                watching = true;
            };

            $scope.preSelectOff = this.preSelectOff;

            // selecting a suggestion with RIGHT ARROW or ENTER
            $scope.select = function(suggestion){
                if(suggestion){
                    $scope.searchParam = suggestion;
                    $scope.searchFilter = suggestion;
                    if($scope.onSelect) {
                        $scope.onSelect(suggestion, $scope.requestType);
                        $scope.selected = true;
                    }
                }
                // $scope.completing = false;
                watching = false;
                setTimeout(function(){
                    watching = true;
                },1000);
                $scope.setIndex(-1);
            };

            angular.element($window).on('click', function (event) {
                var target = $(event.target);

                if(target.hasClass("search-online-combo")) {
                    // just ignore
                } else {
                    // Do whatever you need
                    $scope.completing = false;
                }
                $scope.$apply();
            });

            $scope.clearField = function () {
                $scope.searchParam = ''
            }

        }],
        link: function(scope, element, attrs){

            setTimeout(function() {
                scope.initLock = false;
                scope.$apply();
            }, 250);

            var attr = '';

            // Default atts
            scope.attrs = {
                "placeholder": "start typing...",
                "class": "",
                "id": "",
                "inputclass": "",
                "inputid": ""
            };

            for (var a in attrs) {
                attr = a.replace('attr', '').toLowerCase();
                // add attribute overriding defaults
                // and preventing duplication
                if (a.indexOf('attr') === 0) {
                    scope.attrs[attr] = attrs[a];
                }
            }

            if (attrs.clickActivation) {
                element[0].onclick = function(e){
                    if(!scope.searchParam){
                        setTimeout(function() {
                            scope.completing = true;
                            scope.$apply();
                        }, 200);
                    }
                };
            }

            var key = {left: 37, up: 38, right: 39, down: 40 , enter: 13, esc: 27, tab: 9};

            document.addEventListener("keydown", function(e){
                var keycode = e.keyCode || e.which;

                switch (keycode){
                    case key.esc:
                        // disable suggestions on escape
                        scope.select();
                        scope.setIndex(-1);
                        scope.$apply();
                        e.preventDefault();
                }
            }, true);

            // document.addEventListener("blur", function(e){
            //     // disable suggestions on blur
            //     // we do a timeout to prevent hiding it before a click event is registered
            //     setTimeout(function() {
            //         // scope.select();
            //         scope.setIndex(-1);
            //         scope.$apply();
            //     }, 150);
            // }, true);

            element[0].addEventListener("keydown",function (e){
                var keycode = e.keyCode || e.which;

                var l = angular.element(this).find('li').length;

                // this allows submitting forms by pressing Enter in the autocompleted field
                if(!scope.completing || l == 0) return;

                // implementation of the up and down movement in the list of suggestions
                switch (keycode){
                    case key.up:

                        index = scope.getIndex()-1;
                        if(index<-1){
                            index = l-1;
                        } else if (index >= l ){
                            index = -1;
                            scope.setIndex(index);
                            scope.preSelectOff();
                            break;
                        }
                        scope.setIndex(index);

                        if(index!==-1)
                            scope.preSelect(angular.element(angular.element(this).find('li')[index+1]).text());

                        scope.$apply();

                        break;
                    case key.down:
                        index = scope.getIndex()+1;
                        if(index<-1){
                            index = l-1;
                        } else if (index >= l ){
                            index = -1;
                            scope.setIndex(index);
                            scope.preSelectOff();
                            scope.$apply();
                            break;
                        }
                        scope.setIndex(index);

                        if(index!==-1)
                            scope.preSelect(angular.element(angular.element(this).find('li')[index+1]).text());

                        break;
                    case key.left:
                        break;
                    case key.right:
                    case key.enter:
                    case key.tab:

                        index = scope.getIndex();
                        // scope.preSelectOff();
                        if(index !== -1) {
                            scope.select(angular.element(angular.element(this).find('li')[index+1]).text());
                            if(keycode == key.enter) {
                                e.preventDefault();
                            }
                        } else {
                            if(keycode == key.enter) {
                                scope.select();
                            }
                        }
                        scope.setIndex(-1);
                        scope.$apply();

                        break;
                    case key.esc:
                        // disable suggestions on escape
                        scope.select();
                        scope.setIndex(-1);
                        scope.$apply();
                        e.preventDefault();
                        break;
                    default:
                        return;
                }

            });

            // lazy loading: when the dropdown is scrolled close to the bottom,
            // ask the Combobox service for the next page of the vocabulary
            var suggestionsList = element.find('ul')[0];
            if (suggestionsList) {
                suggestionsList.addEventListener('scroll', function () {
                    var nearBottom = suggestionsList.scrollTop + suggestionsList.clientHeight >= suggestionsList.scrollHeight - 30;
                    if (nearBottom) {
                        scope.$applyAsync(function () {
                            scope.Combo.loadMore();
                        });
                    }
                });
            }
        },
        template:require('../templates/index.html'),
    };
});

app.filter('highlight', ['$sce', function ($sce) {
    return function (input, searchParam) {
        if (typeof input === 'function') return '';
        if (searchParam) {
            var words = '(' +
                    searchParam.split(/\ /).join(' |') + '|' +
                    searchParam.split(/\ /).join('|') +
                    ')',
                exp = new RegExp(words, 'gi');
            if (words.length) {
                input = input.replace(exp, "<span class=\"highlight\">$1</span>");
            }
        }
        return $sce.trustAsHtml(input);
    };
}]);

app.directive('suggestion', function(){
    return {
        restrict: 'A',
        require: '^autocomplete', // ^look for controller on parents element
        link: function(scope, element, attrs, autoCtrl){
            element.bind('mouseenter', function() {
                autoCtrl.preSelect(attrs.val);
                autoCtrl.setIndex(attrs.index);
            });

            element.bind('mouseleave', function() {
                autoCtrl.preSelectOff();
            });
        }
    };
});


module.exports = angular;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/autocomplete/directives/autocomplete.directive.js
 ** module id = 128
 ** module chunks = 1
 **/